import { render, staticRenderFns } from "./QualificationsAdd.vue?vue&type=template&id=02dc0930&scoped=true&"
import script from "./QualificationsAdd.vue?vue&type=script&lang=js&"
export * from "./QualificationsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc0930",
  null
  
)

export default component.exports